import { useState, useEffect } from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import "../components/CSS/SummaryReport.css";
import {
  Star,
  CheckCircle,
  Circle,
  XCircle,
  QrCode,
  MessageSquare,
  Clock,
  Users,
  MessageCircle,
  FileText,
  Mail,
  ChefHat,
  ParkingMeterIcon as Parking,
  Volume2,
  Calendar,
  CheckCircle2,
  AlertCircle,
} from "lucide-react";
import { Line, Doughnut } from "react-chartjs-2";
import { Chart, registerables } from "chart.js";
import {
  review_summary,
  server_post_data,
} from "../ServiceConnection/serviceconnection";
import { handleError } from "../CommonJquery/CommonJquery";
import { retrieveData } from "../LocalConnection/LocalConnection";
Chart.register(...registerables);
export default function SummaryReport() {
  const [metrics, setMetrics] = useState({
    totalReviews: {
      value: 248,
      change: 12,
      changeType: "increase",
    },
    averageRating: {
      value: 4.7,
      change: 0.2,
      changeType: "increase",
    },
    positiveReviews: {
      value: 186,
      percentage: 75,
    },
    neutralReviews: {
      value: 42,
      percentage: 17,
    },
    negativeReviews: {
      value: 20,
      percentage: 8,
      changeType: "decrease",
    },
    qrScans: {
      value: 156,
      change: 23,
      changeType: "increase",
    },
    replied: {
      value: 194,
      percentage: 78,
    },
    unreplied: {
      value: 54,
    },
  });
  const metricConfig = [
    {
      key: "totalReviews",
      title: "Total Reviews",
      icon: FileText,
      iconColor: "blue",
      showChange: true,
      changeUnit: "%",
      changeLabel: "from last period",
    },
    {
      key: "averageRating",
      title: "Average Rating",
      icon: Star,
      iconColor: "yellow",
      iconFill: "#F59E0B",
      showStar: true,
      showChange: true,
      changeLabel: "from last period",
    },
    {
      key: "positiveReviews",
      title: "Positive Reviews",
      icon: CheckCircle,
      iconColor: "green",
      showPercentage: true,
      percentageLabel: "of total",
    },
    {
      key: "neutralReviews",
      title: "Neutral Reviews",
      icon: Circle,
      iconColor: "yellow",
      showPercentage: true,
      percentageLabel: "of total",
      noArrow: true,
    },
    {
      key: "negativeReviews",
      title: "Negative Reviews",
      icon: XCircle,
      iconColor: "red",
      showPercentage: true,
      percentageLabel: "of total",
    },
    {
      key: "qrScans",
      title: "QR Scans",
      icon: QrCode,
      iconColor: "purple",
      showChange: true,
      changeUnit: "%",
      changeLabel: "from last period",
    },
  ];

  // Function to get arrow based on change type
  const getArrow = (changeType, noArrow) => {
    if (noArrow) return <span className="dash">—</span>;

    switch (changeType) {
      case "increase":
        return <span className="arrow up">↑</span>;
      case "decrease":
        return <span className="arrow down">↓</span>;
      default:
        return <span className="dash">—</span>;
    }
  };

  // Function to get change text color
  const getChangeColor = (changeType) => {
    switch (changeType) {
      case "increase":
        return "green";
      case "decrease":
        return "red";
      default:
        return "";
    }
  };

  const getIconColorClass = (color) => {
    return `${color}-icon`;
  };

  // Reviews over time data
  const [reviewsData, setReviewsData] = useState({
    labels: [
      "Jan 1",
      "Jan 5",
      "Jan 10",
      "Jan 15",
      "Jan 20",
      "Jan 25",
      "Jan 30",
    ],
    datasets: [
      {
        label: "Reviews",
        data: [12, 19, 15, 24, 21, 30, 28],
        fill: false,
        backgroundColor: "rgba(75, 192, 192, 0.2)",
        borderColor: "#2563eb",
        tension: 0.4,
        pointRadius: 4,
      },
    ],
  });

  // Sentiment distribution data
  const [sentimentData, setSentimentData] = useState({
    labels: ["Positive", "Neutral", "Negative"],
    datasets: [
      {
        data: [75, 17, 8], // Using the percentages from metrics
        backgroundColor: ["#4ade80", "#facc15", "#f87171"],
        hoverBackgroundColor: ["#22c55e", "#eab308", "#ef4444"],
        borderWidth: 0,
      },
    ],
  });

  // Chart options
  const lineOptions = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: false,
      },
      title: {
        display: false,
      },
    },
    scales: {
      y: {
        beginAtZero: true,
        grid: {
          color: "rgba(0, 0, 0, 0.05)",
        },
      },
      x: {
        grid: {
          display: false,
        },
      },
    },
  };

  const doughnutOptions = {
    responsive: true,
    maintainAspectRatio: false,
    cutout: "70%",
    plugins: {
      legend: {
        display: true, // ✅ turn on legend
        position: "bottom", // or 'right', 'top'
        labels: {
          color: "#333", // adjust for dark/light themes
          usePointStyle: true, // makes it a circle instead of square
          pointStyle: "circle",
          padding: 8,
          font: {
            size: 10,
            weight: "500",
          },
        },
      },
    },
  };

  // review Highlighted Div
  const [highlightsData, setHighlightsData] = useState({
    positiveKeywords: [
      "Delicious food",
      "Friendly staff",
      "Clean",
      "Great atmosphere",
      "Excellent service",
      "Welcoming",
      "Professional",
      "Attentive",
      "Fresh ingredients",
      "Reasonable prices",
      "Cozy",
      "Prompt",
      "Tasty",
      "Accommodating",
      "Relaxing",
    ],
    negativeKeywords: [
      "Slow billing",
      "Long wait",
      "Understaffed",
      "Expensive",
      "Limited options",
      "Noisy",
      "Crowded",
      "Slow service",
      "Vegetarian options",
      "Parking",
    ],
    topPositiveReview: {
      rating: 5,
      platform: "Google",
      date: "Jan 10, 2023",
      text: "Amazing experience! The staff was incredibly friendly and attentive. Food was delicious and the atmosphere was perfect for our anniversary dinner. Will definitely go back!",
      reviewer: "Sarah M.",
    },
    topNegativeReview: {
      rating: 2,
      platform: "Yelp",
      date: "Jan 29, 2023",
      text: "Food was good, but we waited 45 minutes for our bill. The restaurant was understaffed during lunch hour and it was very crowded. Need more vegetarian options on the menu.",
      reviewer: "Michael T.",
    },
    suggestions: [
      {
        icon: <Clock size={20} />,
        title: "Improve billing process speed",
        description:
          "Implement mobile payment options or tableside payment systems to reduce wait times for bills.",
      },
      {
        icon: <Users size={20} />,
        title: "Add more staff during lunch hours",
        description:
          "Schedule additional servers between 12-2pm to handle peak traffic and reduce wait times.",
      },
      {
        icon: <ChefHat size={20} />,
        title: "Expand vegetarian menu options",
        description:
          "Add 3-5 new vegetarian dishes to address customer feedback about limited options.",
      },
    ],
  });

  const renderStars = (rating) => {
    return Array.from({ length: 5 }, (_, index) => (
      <Star
        key={index}
        size={14}
        fill={index < rating ? "#fbbf24" : "none"}
        color={index < rating ? "#fbbf24" : "#d1d5db"}
      />
    ));
  };

  // -----------suggestion Imp Div
  const [improvements, setImprovements] = useState([
    {
      id: 1,
      title: "Improve billing process speed",
      icon: <Clock size={20} color="#3b82f6" />,
      description:
        "68% of negative reviews mention slow billing. Consider implementing tableside payment systems or mobile payment options.",
      priority: "high",
      actions: [
        "Research POS systems with tableside payment options",
        "Train staff on expedited checkout procedures",
        "Implement QR code payment option or receipts",
      ],
    },
    {
      id: 2,
      title: "Add more staff during lunch hours",
      icon: <Users size={20} color="#3b82f6" />,
      description:
        "Wait times between 12-2pm are mentioned in 42% of negative reviews. Current staffing appears insufficient for peak periods.",
      priority: "high",
      actions: [
        "Hire 2 additional part-time servers for lunch shifts",
        "Adjust kitchen staff scheduling to increase capacity",
        "Consider lunch pre-order system for regular customers",
      ],
    },
    {
      id: 3,
      title: "Expand vegetarian menu options",
      icon: <ChefHat size={20} color="#3b82f6" />,
      description:
        "23% of feedback mentions limited vegetarian options. Adding more plant-based dishes could attract new customers.",
      priority: "medium",
      actions: [
        "Add 3-5 new vegetarian dishes to the menu",
        "Highlight vegetarian options on menu with special icon",
        "Run a 'Meatless Monday' promotion to test new dishes",
      ],
    },
    {
      id: 4,
      title: "Improve parking situation",
      icon: <Parking size={20} color="#3b82f6" />,
      description:
        "15% of negative reviews mention parking difficulties. Limited parking may be deterring potential customers.",
      priority: "medium",
      actions: [
        "Negotiate with nearby businesses for shared parking",
        "Add parking information to website and reservation emails",
        "Consider valet service during peak hours",
      ],
    },
    {
      id: 5,
      title: "Reduce noise levels",
      icon: <Volume2 size={20} color="#3b82f6" />,
      description:
        "12% of reviews mention noise levels being too high, particularly during weekend evenings. This affects dining experience.",
      priority: "low",
      actions: [
        "Install acoustic panels or sound-absorbing materials",
        "Adjust music volume based on occupancy levels",
        "Create a 'quiet section' for customers who prefer it",
      ],
    },
    {
      id: 6,
      title: "Implement reservation system",
      icon: <Calendar size={20} color="#3b82f6" />,
      description:
        "10% of reviews mention difficulty getting a table without long waits. A better reservation system could improve experience.",
      priority: "low",
      actions: [
        "Implement online reservation system with text notifications",
        "Create a waitlist app for walk-in customers",
        "Offer incentives for off-peak dining times",
      ],
    },
  ]);

  const getPriorityIcon = (priority) => {
    switch (priority) {
      case "high":
        return <AlertCircle size={16} color="#f59e0b" />;
      case "medium":
        return <AlertCircle size={16} color="#3b82f6" />;
      case "low":
        return <AlertCircle size={16} color="#6b7280" />;
      default:
        return null;
    }
  };

  const getPriorityText = (priority) => {
    return priority.charAt(0).toUpperCase() + priority.slice(1) + " priority";
  };

  const periodSelected = retrieveData("period");
  const [ShowLoaderAdmin, setShowLoaderAdmin] = useState(false);
  const master_data_get = async (start, end, period) => {
    setShowLoaderAdmin(true);
    let formdata = new FormData();
    formdata.append("from_date", start);
    formdata.append("to_date", end);
    formdata.append("click_type", period);
    await server_post_data(review_summary, formdata)
      .then((Response) => {
        let data = Response.message.split("~@~");
        const final_data = JSON.parse(data[1]);
        if (parseInt(data[0]) === 1) {
          handleError(final_data.message);
        } else {
          const review_overview = final_data.review_overview;
          const review_sentiment =
            final_data.review_sentiment &&
            final_data.review_sentiment.length > 0
              ? final_data.review_sentiment[0]
              : [];
          const review_overtimegraph = final_data.review_overtimegraph;

          const replyPercentage =
            (review_overview.total_replied /
              (review_overview.total_replied +
                review_overview.total_unreplied)) *
            100;

          setMetrics({
            totalReviews: {
              value: review_overview.total_review,
              change: review_overview.review_change_percent,
              changeType: getChangeType(review_overview.review_change_percent),
            },
            averageRating: {
              value: review_overview.total_avg_rating,
              change: review_overview.avg_rating_change_percent,
              changeType: getChangeType(
                review_overview.avg_rating_change_percent,
              ),
            },
            positiveReviews: {
              value: review_overview.total_positive,
              percentage: review_overview.positive_change_percent,
              changeType: getChangeType(
                review_overview.positive_change_percent,
              ),
            },
            neutralReviews: {
              value: review_overview.total_neutral,
              percentage: review_overview.neutral_change_percent,
              changeType: getChangeType(review_overview.neutral_change_percent),
            },
            negativeReviews: {
              value: review_overview.total_negative,
              percentage: review_overview.negative_change_percent,
              changeType: getChangeType(
                review_overview.negative_change_percent,
              ),
            },
            qrScans: {
              value: review_overview.total_qr_scan,
              change: review_overview.qr_scan_change_percent,
              changeType: getChangeType(review_overview.qr_scan_change_percent),
            },
            replied: {
              value: review_overview.total_replied,
              percentage: replyPercentage.toFixed(1),
              changeType: getChangeType(review_overview.replied_change_percent),
            },
            unreplied: {
              value: review_overview.total_unreplied,
              percentage: review_overview.unreplied_change_percent,
              changeType: getChangeType(
                review_overview.unreplied_change_percent,
              ),
            },
          });
          setSentimentData((prev) => ({
            ...prev,
            datasets: [
              {
                ...prev.datasets[0],
                data: [
                  review_sentiment.total_positive,
                  review_sentiment.total_neutral,
                  review_sentiment.total_negative,
                ],
              },
            ],
          }));
          if (review_overtimegraph.length > 0) {
            // Extract labels and data from normalized data
            const labels = review_overtimegraph.map((item) => item.month_name); // or use item.date for full date
            const data = review_overtimegraph.map((item) => item.total_count);
            // Update chart data once
            setReviewsData({
              labels,
              datasets: [
                {
                  ...reviewsData.datasets[0],
                  data,
                },
              ],
            });
          }
        }

        setShowLoaderAdmin(false);
      })
      .catch((error) => {
        handleError("network");
        setShowLoaderAdmin(false);
      });
  };

  const getChangeType = (value) => {
    if (value > 0) return "increase";
    if (value < 0) return "decrease";
    return "";
  };
  useEffect(() => {
    master_data_get("", "", periodSelected);
  }, []);
  const handleDateSelection = (start, end, period) => {
    // Typically you would fetch API data here
    master_data_get(start, end, period);
  };

  return (
    <MasterLayout>
      <Breadcrumb
        title="Review Summary Report"
        onDateSelection={handleDateSelection}
      />
      <div className="report_summery_contr">
        <div className="report_over">
          <h2 className="title_summerys_head">Review Overview</h2>
          <div className="row g-3">
            {/* Dynamic Metric Cards */}
            {metricConfig.map((config) => {
              const metricData = metrics[config.key];
              const IconComponent = config.icon;

              return (
                <div key={config.key} className="col-12 col-sm-6 col-lg-3">
                  <div className="metric-card h-100">
                    <div className="metric-header">{config.title}</div>

                    <div className="metric-value">
                      {metricData.value}
                      {config.showStar && (
                        <span className="star-inline">★</span>
                      )}
                    </div>

                    <div
                      className={`metric-icon ${getIconColorClass(
                        config.iconColor,
                      )}`}
                    >
                      <IconComponent
                        size={18}
                        fill={config.iconFill || "currentColor"}
                      />
                    </div>

                    {/* <div className="metric-footer">
                      {getArrow(metricData.changeType, config.noArrow)}

                      <span
                        className={`change-value ${getChangeColor(
                          metricData.changeType
                        )}`}
                      >
                        {config.showChange &&
                          metricData.change &&
                          `${metricData.change}${config.changeUnit || ""} ${
                            config.changeLabel
                          }`}

                        {config.showPercentage &&
                          metricData.percentage &&
                          `${metricData.percentage}% ${config.percentageLabel}`}
                      </span>
                    </div> */}
                  </div>
                </div>
              );
            })}

            {/* Replied vs Unreplied Card */}
            <div className="col-12 col-lg-6">
              <div className="metric-card replied-card h-100">
                <div className="metric-header">Replied vs Unreplied</div>
                <div className="metric-icon blue-icon message-icon">
                  <MessageSquare size={18} />
                </div>

                <div className="negPostiveDIv">
                  <div className="progressConter">
                    <div
                      className="progrs"
                      style={{ width: `${metrics.replied.percentage}%` }}
                    ></div>
                  </div>
                  <div className="progress-percentage">
                    {metrics.replied.percentage}%
                  </div>
                </div>

                <div className="progress-labels">
                  <div className="progress-label">
                    <div className="dot blue-dot"></div>
                    <span>Replied ({metrics.replied.value})</span>
                  </div>
                  <div className="progress-label">
                    <div className="dot gray-dot"></div>
                    <span>Unreplied ({metrics.unreplied.value})</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/*------------Performace Analytics-------*/}
        <div className="report_over2  Performance_analytics  ">
          <h2 className="title_summerys_head">Performance Analytics</h2>
          <div className="row g-3">
            <div className="col-12 col-lg-6">
              <div className="metric-card h-100">
                <div className="chart-container">
                  <Line data={reviewsData} options={lineOptions} />
                </div>
              </div>
            </div>
            <div className="col-12 col-lg-6">
              <div className="metric-card h-100">
                <div className="metric-header mb-3">Sentiment Distribution</div>
                {/* <div className="sentiment-legend d-flex justify-content-center mb-2">
                  <div className="progress-label">
                    <div className="dot green-dot"></div>
                    <span>Positive</span>
                  </div>
                  <div className="progress-label">
                    <div className="dot yellow-dot"></div>
                    <span>Neutral</span>
                  </div>
                  <div className="progress-label">
                    <div className="dot red-dot"></div>
                    <span>Negative</span>
                  </div>
                </div> */}
                <div className="chart-container">
                  <Doughnut data={sentimentData} options={doughnutOptions} />
                </div>
              </div>
            </div>
          </div>
        </div>
        {/*------------Review Highlights-------*/}
        <div className="report_over2 Review_highLights hidden">
          <h2 className="title_summerys_head">Review Highlights</h2>
          <div className="row">
            <div className="col-md-6">
              <div className="keywords-section">
                <div className="keywords-header positive-header">
                  <div className="keywords-indicator positive-indicator"></div>
                  <span>Positive Keywords</span>
                </div>
                <div className="keywords-container">
                  {highlightsData.positiveKeywords.map((keyword, index) => (
                    <span key={index} className="keyword-tag positive-tag">
                      {keyword}
                    </span>
                  ))}
                </div>
                {/**------top Positive Review-------- */}
                <span className="review-title">Top Positive Review</span>
                <div className="review-card">
                  <div className="review-header"></div>
                  <div className="review-rating">
                    <div className="stars-container">
                      {renderStars(highlightsData.topPositiveReview.rating)}
                    </div>
                    <span className="review-platform">
                      {highlightsData.topPositiveReview.platform} •{" "}
                      {highlightsData.topPositiveReview.date}
                    </span>
                  </div>
                  <div className="review-text">
                    "{highlightsData.topPositiveReview.text}"
                  </div>
                  <div className="review-author">
                    - {highlightsData.topPositiveReview.reviewer}
                  </div>
                </div>
              </div>
            </div>

            <div className="col-md-6">
              <div className="keywords-section">
                <div className="keywords-header negative-header">
                  <div className="keywords-indicator negative-indicator"></div>
                  <span>Negative Keywords</span>
                </div>
                <div className="keywords-container">
                  {highlightsData.negativeKeywords.map((keyword, index) => (
                    <span key={index} className="keyword-tag negative-tag">
                      {keyword}
                    </span>
                  ))}
                </div>
                {/**------top Negitive Review-------- */}
                <span className="review-title">Top Negative Review</span>
                <div className="review-card">
                  <div className="review-header"></div>
                  <div className="review-rating">
                    <div className="stars-container">
                      {renderStars(highlightsData.topNegativeReview.rating)}
                    </div>
                    <span className="review-platform">
                      {highlightsData.topNegativeReview.platform} •{" "}
                      {highlightsData.topNegativeReview.date}
                    </span>
                  </div>
                  <div className="review-text">
                    "{highlightsData.topNegativeReview.text}"
                  </div>
                  <div className="review-author">
                    - {highlightsData.topNegativeReview.reviewer}
                  </div>
                  <button className="reply-btn">
                    <MessageCircle size={14} />
                    Reply Now
                  </button>
                </div>
              </div>
            </div>

            {/* <div className="col-md-12">
              <div className="reviews-and-suggestions">
            
                <div className="suggestions-section">
                  <div className="suggestions-header">
                    <TrendingUp size={18} color="#3b82f6" />
                    <span>Suggested Improvements (AI Insights)</span>
                  </div>
                  <div className="suggestions-grid">
                    {highlightsData.suggestions.map((suggestion, index) => (
                      <div key={index} className="suggestion-card">
                        <div className="suggestion-icon">{suggestion.icon}</div>
                        <div className="suggestion-content">
                          <div className="suggestion-title">
                            {suggestion.title}
                          </div>
                          <div className="suggestion-description">
                            {suggestion.description}
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div> */}
          </div>
        </div>

        {/*------------Suggested Improvements-------*/}
        <div className="report_over2 Suggested_improvemnt_div hidden">
          <h2 className="title_summerys_head">
            Suggested Improvements (AI Insights)
          </h2>
          <div className="suggested-improvements-container">
            <div className="row g-3">
              {improvements.map((improvement) => (
                <div
                  key={improvement.id}
                  className="col-12 col-md-6 col-lg-4 mb-3"
                >
                  <div className="improvement-card">
                    <div className="improvement-header">
                      <div className="improvement-icon">{improvement.icon}</div>
                      <div className="improvement-title">
                        {improvement.title}
                      </div>
                    </div>
                    <div className="improvement-description">
                      {improvement.description}
                    </div>
                    <div className="improvement-priority">
                      {getPriorityIcon(improvement.priority)}
                      <span className={`priority-text ${improvement.priority}`}>
                        {getPriorityText(improvement.priority)}
                      </span>
                    </div>
                    <div className="recommended-actions">
                      <div className="actions-header">Recommended Actions:</div>
                      <ul className="actions-list">
                        {improvement.actions.map((action, index) => (
                          <li key={index} className="action-item">
                            <CheckCircle2 size={16} className="action-check" />
                            <span>{action}</span>
                          </li>
                        ))}
                      </ul>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
        <div className="report_over2 Take_action_bttn hidden">
          <p>Take Action</p>
          <div className="take_ac_bttn">
            <button type="button" className="exPBttn">
              <FileText size={16} style={{ marginRight: "5px" }} />
              Export PDF
            </button>
            <button type="button" className="reply_n_btn">
              <Mail size={16} style={{ marginRight: "5px" }} />
              Reply Now
            </button>
          </div>
        </div>
      </div>
    </MasterLayout>
  );
}
